import { render, staticRenderFns } from "./ArchivoImagen.vue?vue&type=template&id=6b19dc9f&scoped=true&"
import script from "./ArchivoImagen.vue?vue&type=script&lang=js&"
export * from "./ArchivoImagen.vue?vue&type=script&lang=js&"
import style0 from "./ArchivoImagen.vue?vue&type=style&index=0&id=6b19dc9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19dc9f",
  null
  
)

export default component.exports